import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Sparkles, Receipt, Headphones } from "lucide-react";

const VALUES = [
  { icon: Sparkles, title: "Kaliteli Filo", text: "Düzenli bakımdan geçen, temiz ve güncel model araçlar." },
  { icon: Receipt, title: "Şeffaflık", text: "Gizli ücret yok, net ve anlaşılır süreç." },
  { icon: ShieldCheck, title: "Güven", text: "Sigortalı araçlar ve açık kiralama koşulları." },
  { icon: Headphones, title: "Müşteri Odaklı", text: "7/24 ulaşılabilir, çözüm odaklı destek ekibi." },
];

export default function About() {
  useEffect(() => { document.title = "Hakkımızda | VoyaCar Rental"; }, []);
  return (
    <div>
      <div className="bg-[#171717] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl sm:text-4xl font-bold">Hakkımızda</h1>
          <p className="mt-2 text-neutral-300">İstanbul'da güvenilir araç kiralamanın adı: VoyaCar Rental.</p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="prose max-w-none">
          <p className="text-lg text-neutral-700 leading-relaxed">
            VoyaCar Rental, İstanbul'da bireysel ve kurumsal müşterilere ekonomik, konforlu ve bakımlı araçlarla kiralama hizmeti sunar. Şehir merkezinden havalimanına kadar esnek teslim seçenekleriyle yanınızdayız.
          </p>
          <p className="text-base text-neutral-600 leading-relaxed mt-4">
            Amacımız, araç kiralama sürecini hızlı, şeffaf ve güvenilir hale getirmek. Online ödeme zorunluluğu olmadan talep oluşturabilir, WhatsApp üzerinden dakikalar içinde ekibimizle iletişime geçebilirsiniz. Her aracımız kiralama öncesi detaylı bakım ve temizlikten geçirilir.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-12">
          {VALUES.map((v) => (
            <div key={v.title} className="bg-white rounded-2xl border border-neutral-200 p-6 flex gap-4" data-testid={`about-value-${v.title}`}>
              <div className="h-12 w-12 shrink-0 rounded-xl bg-[#FFF0F2] flex items-center justify-center"><v.icon className="h-6 w-6 text-[#A11016]" /></div>
              <div><h3 className="font-semibold text-[#171717]">{v.title}</h3><p className="text-sm text-neutral-500 mt-1">{v.text}</p></div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/araclar"><Button className="h-12 px-8 bg-[#A11016] hover:bg-[#820D12] text-white font-semibold" data-testid="about-cta-button">Araçları İncele</Button></Link>
        </div>
      </div>
    </div>
  );
}
